import React, {Component} from 'react';
import Button, { ButtonGroup } from '@atlaskit/button';
import {FormFooter} from '@atlaskit/form';
import {Grid, GridColumn} from '@atlaskit/page';
import ContentWrapper from '../../components/ContentWrapper';
import {connect} from 'react-redux';
import ClientActions from '../../redux/ClientRedux';
import CarsActions from '../../redux/CarsRedux';
import DictionariesActions from '../../redux/DictionariesRedux';
import {FormSection} from '../../components/FormFields';
import {CarCheckForm, CarFormFields} from './components/CarAddForm';
import {ClientPassportFields} from './components/ClientPassportForm';
import {ClientInfoFields} from  './components/ClientInfoForm';
import Forbidden from '../../components/Forbidden';
import {withTranslation, Trans} from 'react-i18next';

class ClientPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      checked: false,
      client: {
        fullName: '',
        dateOfBirth: undefined,
        dateOfLicense: undefined,
        // Дoбавлено значение, так как нет валидации поля Select
        gender: {id: 1, name: "Мужской"},
        passport: {
          series: '',
          number: '',
          issuedAt: undefined,
          issuedBy: '',
          authority: '',
          regAddress: '',
        },
        livingAddress: '',
        email: '',
        phone: '',
        note: '',
        car: {
          vin: '',
          epts: '',
          make: '',
          model: '',
          year: '',
          color: '',
          plate: '',
          agents: [],
          system: {},
        },
      },
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.fetching !== this.props.fetching
      && prevProps.fetching
      && !this.props.error
      && this.props.client
      && this.props.client.id) {
        // Клиент создан
        this.props.history.goBack();

    } else if (prevProps.carFetching !== this.props.carFetching
      && prevProps.carFetching
      && !this.props.carError
      && this.props.car
      && this.props.car.vin
      && this.props.car.epts) {
      // Проверка прошла, пришли данные с проверки
      this.setState({
        client: {
          ...this.state.client,
          car: {
            ...this.state.client.car,
            ...this.props.car
          }
        },
        checked: true,
      });
    }
  }

  onDelete = e => {
    e.preventDefault();
    this.props.delete(this.props.client.id);
  }

  onCancel = e => {
    e.preventDefault();
    this.props.history.goBack();
  }

  onFormSubmit = e => {
    e.preventDefault();
    const {create} = this.props;
    const {client} = this.state;
    if (!client) {
      //waranty: Должен быть вывод ошибки, так как из required для select не работает.

    } else {
      create(client)
    }
  }

  onCheckFormSubmit = e => {
    e.preventDefault();
    const {car = {}} = this.state.client;
    this.props.checkCar(car.vin, car.epts);
  }

  onChange = (name, value) => {
    if (name.includes('.')) {
      const path = name.split('.');
      if (path.length === 2) {
        let obj = {...this.state.client[path[0]]};
        obj[path[1]] = value;
        this.setState({
          client: {...this.state.client, [path[0]]: obj},
        });
      }
    } else {
      this.setState({
        client: {...this.state.client, [name]: value},
      });
    }
  }

  render() {
    const {client, checked} = this.state;
    const {
      fetching,
      dictionaries,
      getDictionaries,
      permissions,
      t,
    } = this.props;

    if (!permissions.create) {
      return <Forbidden />;
    }

    const disabled = fetching || !checked;
    
    return (
      <ContentWrapper>
        <h1>{t('Create new client')}</h1>
        {!checked && (
          <CarCheckForm
            car={client.car}
            onChange={this.onChange}
            fetching={fetching}
            onSubmit={this.onCheckFormSubmit}
            onClose={this.onCancel}
          />
        )}
        <form onSubmit={this.onFormSubmit}>
          <Grid>
            <CarFormFields
              showCheckedFields={checked}
              car={client.car}
              onChange={this.onChange}
              fetching={disabled}
            />
            <GridColumn medium={12}>
              <FormSection>{t('Client')}</FormSection>
            </GridColumn>
            <ClientInfoFields
              {...client}
              onChange={this.onChange}
              dictionaries={dictionaries}
              getDictionaries={getDictionaries}
              fetching={disabled}
            />
            <GridColumn medium={12}>
              <FormSection>{t('Passport details')}</FormSection>
            </GridColumn>
            <ClientPassportFields
              passport={client.passport}
              livingAddress={client.livingAddress}
              onChange={this.onChange}
              fetching={disabled}
            />
            <GridColumn>
              <FormFooter>
                <ButtonGroup>
                  {checked && (
                    <Button appearance='subtle' isDisabled={fetching} onClick={this.onCancel}>
                      <Trans>Cancel</Trans>
                    </Button>
                  )}
                  <Button type='submit' isDisabled={disabled} isLoading={fetching} appearance='danger'>
                    <Trans>Register</Trans>
                  </Button>
                </ButtonGroup>
              </FormFooter>
            </GridColumn>
          </Grid>
        </form>
      </ContentWrapper>
    );
  }
}
const mapStateToProps = state => {
  return {
    permissions: state.userProfile.permissions.client,
    client: state.client.data,
    fetching: state.client.fetching,
    error: state.client.error,
    car: state.cars.data && state.cars.data.new,
    carFetching: state.cars.fetching,
    carError: state.cars.error,
    dictionaries: state.dictionaries, 
  };
};

const mapDispatchToProps = dispatch => {
  return {
    create: data => dispatch(ClientActions.clientAddRequest(data)),
    update: data => dispatch(ClientActions.clientUpdateRequest(data)),
    delete: id => dispatch(ClientActions.clientDeleteRequest(id)),
    getDictionaries: name => () => dispatch(DictionariesActions.dictionariesRequest(name)),
    checkCar: (vin, epts) => dispatch(CarsActions.carCheckRequest(vin, epts)),
  };
};

export default withTranslation('clients', 'common')(connect(
  mapStateToProps,
  mapDispatchToProps,
)(ClientPage));
